import React from "react";

const PatientVisit = () => {
  return (
    <div>
      <h1>This is the patientvisit page</h1>
    </div>
  );
};

export default PatientVisit;
